let config = {};

//production Base URL
   config['API']="https://peachpuff-toad-230421.hostingersite.com/api";
//development Base URL
//  config['API'] = 'https://hotpink-antelope-481452.hostingersite.com/api';
//  config['API'] = 'https://api.pragpms.com/api';
//  config['API'] = 'http://localhost:8000/api';
export default config;